import { render, staticRenderFns } from "./Rating3Star.vue?vue&type=template&id=56cac8e8"
import script from "./Rating3Star.vue?vue&type=script&lang=js"
export * from "./Rating3Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56cac8e8')) {
      api.createRecord('56cac8e8', component.options)
    } else {
      api.reload('56cac8e8', component.options)
    }
    module.hot.accept("./Rating3Star.vue?vue&type=template&id=56cac8e8", function () {
      api.rerender('56cac8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Rating3Star.vue"
export default component.exports